export default {
    methods: {
        addUnit: function() {

            let _this = this;
            this.addingUnit = true;
            axios.post('/order-line/add-unit/' + this.order.id)
                .then(function(response) {
                    _this.order.pieces += 1;

                    _this.addingUnit = false;
                }, this)
                .catch(function(error) {});
        },
        removeUnit: function() {
            let _this = this;
            this.removingUnit = true;
            axios.post('/order-line/remove-unit/' + this.order.id)
                .then(function(response) {
                    _this.order.pieces -= 1;
                    _this.removingUnit = false;

                }, this)
                .catch(function(error) {

                });
        },
        deleteOrderLine: function(id) {

            let _this = this;

            axios.post('/order-line/delete/' + id)
                .then(function(response) {
                    _this.removeOrderLine(id);
                    window.decrementShoppingCart();
                    _this.$awn.success("Uw product is verwijderd uit de winkelwagen!");
                }, _this)
                .catch(function(error) {
                    _this.$awn.alert("Oeps, daar ging iets mis, probeert u het later nog eens");
                });

            WinkelwagenEventBus.$emit("winkelwagen-remove-orderline", this.order);
        },
        changeOrderType: function(order, event, currentStatus) {

            event.preventDefault();

            if (order.order_offer === currentStatus) {
                return;
            }

            WinkelwagenEventBus.$emit("disable-radios");

            let _this = this;

            axios.post('/order-line/change/' + order.id)
                .then(function(response) {
                    WinkelwagenEventBus.$emit('winkelwagen-changeOrderType', order);
                    WinkelwagenEventBus.$emit("enable-radios");
                    let lijst = order.order_offer ? "bestel" : "offerte";
                    _this.$awn.success("Het product is toegevoegd aan de " + lijst + " lijst");
                }, _this)
                .catch(function(error) {
                    _this.$awn.alert("Oeps, daar ging iets mis, probeert u het later nog eens");
                }, _this);
        }
    },
    computed: {
        canSwitchOrderOffer: function() {
            if (this.order.residual_product_id) {
                return false;
            }
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/cart/helpers/product/customer.js